import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import * as ROUTES from "../../constants/routes";

const NewUserMessageDialog = ({ open, onCreateRescuerMessage, waittingForAccountCompleted, setIsSigningUp, setOpenSignUpModal, isSigningUp, setwaittingForAccountCompleted }) => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <Dialog aria-labelledby="rescuer-onCreate-Modal" open={open} fullWidth maxWidth={"xs"}>
      <DialogTitle id="rescuer-onCreate-Modal">{onCreateRescuerMessage.success ? t("succesRescuerSignUp") : t("errorOnRescuerSignUp")}</DialogTitle>
      <DialogContent>
        <Typography>{!waittingForAccountCompleted && t(onCreateRescuerMessage.msg)}</Typography>
        {waittingForAccountCompleted && (
          <Grid item xs={12} container justify="center" alignItems="center">
            <div
              style={{
                minHeight: 170,
              }}
            >
              <div class="heart pulse" style={{ marginTop: "15%", marginLeft: "33%" }}></div>
              <Typography variant="h6" style={{ marginTop: 32 }}>
                {t("signUpThanks")}
              </Typography>
            </div>
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setIsSigningUp(true);
            setwaittingForAccountCompleted(true);
            if (onCreateRescuerMessage.success) {
              setTimeout(() => {
                setIsSigningUp(false);
                onCreateRescuerMessage.success ? history.push(ROUTES.SIGN_IN) : setOpenSignUpModal(false);
              }, 6000);
            } else {
              //history.push(ROUTES.SIGN_IN);
              window.location.reload(false);
            }
          }}
        >
          {!onCreateRescuerMessage.success ? t("home") : "OK"}

          {isSigningUp && (
            <CircularProgress
              size={24}
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                marginTop: -12,
                marginLeft: -12,
              }}
            />
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewUserMessageDialog;
